import * as React from 'react';
import { useState } from "react";
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import StatusContext from '../../../contexts/StatusContext'
import AuthContext from "../../../contexts/AuthContext";
import { PushButton } from '../pushbutton/PushButton';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { ProgressIcon } from '../customicons/ProgressIcon';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import axios from 'axios'
import { config } from "../../../config";
import { LoginConfirmDialog } from '../loginconfirmdialog/LoginConfirmDialog';


export const  DialogLogin = () => {

  const[loginstatus, setLoginStatus] = useState('')
   
  
    const {
        changeLanguage,
        isLoading,
        setIsLoading,
        showlogindialog,
        setShowLoginDialog,
      
        setShowSignupDialog,
        setShowSignupConfirmDialog,
        setEnableSignupDialog,

        setShowLoginConfirmDialog,

        logininputs,
        setLoginInputs,

        setSecurityCodeStatus,
        setShowNewPasswordDialog,
     
    } = React.useContext(StatusContext);

    let {
      login,
     
    } = React.useContext(AuthContext);

    const handleSignup = () => {
      setEnableSignupDialog(true)
      setShowSignupDialog(true)
      setShowLoginDialog(false)
     
    }

       // eslint-disable-next-line
    const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    const isValidEmail = (email) => {
      return emailRegex.test(String(email).toLowerCase());
    }

    const verifySecurityCode = (securitycode) => {

      const userid = JSON.parse(localStorage.getItem('LoginVerification'))
    
      if (securitycode === userid.verificationtoken)
      {
      
        setShowLoginConfirmDialog(false)
      
        setShowNewPasswordDialog(true)
      }
      else{
        setSecurityCodeStatus(changeLanguage("signup", "invalidsecuritycode"))
        return

      }
      setEnableSignupDialog(false)
      setShowLoginConfirmDialog(false)

      handleClose()
    }

    
    const onClickForgotPassword = async (e) => {
      
      e.preventDefault()

      setLoginStatus('')

      if (!isValidEmail(logininputs.username))
      {

        setLoginStatus(changeLanguage('status', 'invalidemail'))
        return;
      }

      //check if user exists

      setIsLoading(true)
      console.log("LoginIput:", logininputs.username)
  
      try {
        let userid = ({
          username:logininputs.username,
        
        })
        await axios.post(config.url.API_URL + "/deda_ai_api/auth/checkuser", userid)
          
      } catch (err) {
         
          if (err.response && err.code === "ECONNRESET")
          {
            setLoginStatus("Connection error")
            setIsLoading(false)
            return
          }

          if (err.response && err.response.status === 404)
          {
            //setLoginStatus("User with this email does not exist.")
            setLoginStatus(changeLanguage('signup', 'noemail'))
            setIsLoading(false)
            return;
          }
      }

//send verification code 
   
      const verification = {
        email: logininputs.username,
        verificationtoken: Math.random().toString(36).substring(2, 8),
      }

      localStorage.setItem("LoginVerification", JSON.stringify(verification))

      try {
         
       
        const res = await axios.post(config.url.API_URL + "/deda_ai_api/auth/send-verification", verification)
        console.log("Email verification sent::", res)
        
        setShowLoginConfirmDialog(true)

       
      } catch (err) {
          console.log("Login err:", err.response.data)
          if (err.response && err.code === "ECONNRESET")
            setLoginStatus("Connection error")
          else{
            setLoginStatus("Server error")
          }
          setIsLoading(false) 
          return;
      }

      setIsLoading(false) 

  }

 
    const handleLogin = async (e) =>{
      e.preventDefault()

   
      setLoginStatus('')

      if (!isValidEmail(logininputs.username))
      {
        setLoginStatus(changeLanguage('status', 'invalidemail'))
        return;
      }

      if (logininputs.password.length < 8)
      {
        setLoginStatus(changeLanguage('login','wrongpassword'))
        return;
      }

    
      setLoginStatus("")

      setIsLoading(true)

      let status = await login(logininputs)
      if (status === 200)
      {
          setShowLoginDialog(false)
      }
      else
      {
        setLoginStatus(changeLanguage('signup', 'loginfailed'))
      }

      setIsLoading(false)
}

    const handleChange = (e) => {
    
       setLoginInputs((prev)=>({...prev,[e.target.name]: e.target.value }))
       setLoginStatus('')
   }

  const handleClose = () => {

    setShowSignupConfirmDialog(false)
    setShowLoginDialog(false);
  };

  return (
    <React.Fragment>
        <Dialog
     
          open={showlogindialog}
          onClose={handleClose}
          PaperProps={{
            component: 'form',
            onSubmit: (event) => {
              event.preventDefault();
              const formData = new FormData(event.currentTarget);
              const formJson = Object.fromEntries(formData.entries());
              const email = formJson.email;
              console.log(email);
              handleClose();
            },
          }}
        >

      <ProgressIcon isLoading={isLoading} /> 
     
      <DialogTitle>Login</DialogTitle>
      <IconButton
        aria-label="close"
        onClick={handleClose}
        sx={{
          position: 'absolute',
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
      >
       <CloseIcon />
      </IconButton>
      <DialogContent>
      <TextField
                autoFocus
                required
                margin="dense"
            
                name="username"
                label="Email Address"
                type="email"
                fullWidth
                variant="standard"
                onChange = {handleChange}
                value = {logininputs.username}
              />

              <TextField
                autoFocus
                required
                margin="dense"
                
                name="password"
                label="Password"
                type="password"
                fullWidth
                variant="standard"
                onChange = {handleChange}
                value = {logininputs.password}
              />

              <br></br>
              <br></br>
              <PushButton label={changeLanguage('login','buttonlogin')} onClick={handleLogin}/>

              {
              (loginstatus) && <div className='signupButton'><label style={{color:'maroon'}}>{loginstatus}</label></div>
              }
           
              <button className="loginForgotButton" disabled = {isLoading} style={{fontWeight: '500'}} onClick={onClickForgotPassword}>{changeLanguage('login','forgotpassword')}</button>
           
            
             
              <div  className="loginText" > 
                <span style={{paddingRight: '10px'}}>{changeLanguage('login','text')}  </span>
                
              
                <Button
                  variant="contained"
                  size = "small"
                  sx={{ height: '3ch', fontStyle:'italic', fontSize: '12px', color: 'black', backgroundColor: 'lightblue'}}
                  onClick={handleSignup}
                  >
                 {changeLanguage('login','signup')}
                 </Button>
              

              </div>
        
      
      
      </DialogContent>
      </Dialog>

      
      <LoginConfirmDialog title={"Login"} text={changeLanguage('status', 'emailverification')} verifySecurityCode = {verifySecurityCode}/>
    
    </React.Fragment>
    
  );
}